import { fetch, formFetch } from './axios'
import { payUrl, walletUrl } from './env.js'

// 登陆
export const logIn = params => fetch('POST', '/agt/login/index', params)

// 获取验证码
export const sendCode = params => fetch('GET', '/agt/login/sendCode', params)

// 开通退款账号
export const registerCoach = params => fetch('GET', '/ec/registerCoach', params)

// 获取城市列表
export const getCities = params => fetch('GET', '/active/cities', params)

// 上传图片
export const uploadImage = params => formFetch('/agt/image/upload', params)

// 服务商申请
export const addAgent = params => fetch('POST', '/agt/agent/apply', params)

// 查看服务商详情
export const getAgent = params => fetch('GET', '/agt/agent/get', params)

// 服务商修改
export const editAgent = params => fetch('GET', '/agt/agent/add', params)

// 服务商收入
export const getIncome = params => fetch('GET', '/agt/my/income', params)

// 服务商收入详情
export const getIncomeDetail = params => fetch('GET', '/agt/my/income_detail', params)

// 服务商设备
export const getDev = params => fetch('GET', '/agt/my/dev', params)

// 服务商订单
export const getOrders = params => fetch('GET', '/agt/my/orders', params)

// 服务商订单详情
export const getOrderDetail = params => fetch('GET', '/agt/my/orderDetail', params)

// 服务商用户信息
export const getInfo = params => fetch('GET', '/agt/my/info', params)

// 我的收入
export const income = params => fetch('GET', '/agt/my/incomeByDevDetail', params)

// 提交订单（废弃）
// export const pushOrder = params => fetch('POST', '/agt/ec/order', params)

// app提交订单（废弃）
// export const appPushOrder = params => fetch('POST', '/ec/order', params)

// 提交订单
export const ecmallOrder = params => fetch('POST', '/ecmall/order', params)

// 获取商品列表
export const getProdcut = params => fetch('GET', '/ec/products', params)

// 登陆
export const unpaidById = params => fetch('GET', '/order/unpaidById', params)

// 学员提交订单
export const pushStudentOrder = params => fetch('GET', '/order/pay', params)

// 学员提交订单（第三方收银平台）
export const appPushStudentOrder = params => fetch('POST', '/HuiFuPay/applyPay', params)

// 获取是否是会员
export const getIsHuiFuPay = params => fetch('GET', '/HuiFuPay/getIsHuiFuPay', params)

// 获取openid
export const getOpenid = params => fetch('GET', 'agt/pay/get_openid', params)

// 查看最后一次订单 (废弃)
// export const getLastOrder = params => fetch('GET', '/ec/lastOrder', params)

// 取消订单
export const cancelOrder = params => fetch('GET', '/ecmall/cancelOrder', params)

// /ecmall/orders 获取租赁设备订单列表
export const getEcmallOrders = params => fetch('GET', '/ecmall/orders', params)

//  获取设备列表
export const getEcmallProducts = params => fetch('GET', '/ecmall/products', params)

//  获取设备
export const getEcmallProduct = params => fetch('GET', '/ecmall/product', params)

//  根据订单编号查询订单
export const getOrderByNo = params => fetch('GET', '/ecmall/orderByNo', params)

//  取消预定订单
export const flashSaleCancelOrder = params => fetch('GET', '/FlashSale/cancelOrder', params)

// 获取车型
export const getCarModel = params => fetch('GET', '/conf/carModel  ', params)

// 我的收入设备列表
export const getIncomeByDev = params => fetch('GET', '/agt/my/incomeByDev', params)

// 生成订单新
export const flashSaleOrderMultiNum = params => fetch('GET', '/FlashSale/orderMultiNum', params)

// 添加学员保险订单
export const insureAdd = params => fetch('GET', '/insure/add', params)

// 添加学员保险订单
export const insureOrderAdd = params => fetch('GET', '/insureOrder/add', params)

// 取消企业版订单
export const ecSaleCancelOrder = params => fetch('GET', '/ecSale/cancelOrder', params)

// 取消流动站订单
export const k2CancelOrder = params => fetch('GET', '/k2/cancelOrder', params)

// 支付
export const pay = params => fetch('GET', '/api.php', params, payUrl)

// 保险购买验证码校验
export const sendCodeCheck = params => fetch('GET', '/agt/login/sendCodeCheck', params)

/**
 * 充值
 */
export const depositRequest = (params) => fetch('POST', '/StudentDuration/recharge', params)

/**
 * 充值
 */
export const depositBanner = (params) => fetch('GET', '/sys/bannerList', params, walletUrl)
/**
 * 获取accode
 */
 export const getAdCode = (params) => fetch('GET', '/comm/currentAdCode', params)


/**
 * 扫码模块
 */
// 扫码出库
export const devOutBound = params => fetch('GET', '/other/devOutBound', params)

// 提交入库
export const devInBound = params => fetch('GET', '/other/devInBound', params)

// 科二配件扫码入库
export const componentInBound = params => fetch('GET', '/other/componentInBound', params)

// 科二配件扫码出库
export const componentOutBound = params => fetch('GET', '/other/componentOutBound', params)

// 检查序列号
export const checkDevSn = params => fetch('GET', '/other/checkDevSn', params)

// 检查订单状态
export const checkComponentOrderState = params => fetch('GET', '/component/orderState', params)
// 模拟器充值学时
export const simulatorPay = params => fetch('POST', '/Simulator/pay', params)
// 充值优化卡校验
export const simulatorChekCard = params => fetch('POST', '/Simulator/checkCard', params)
// 获取充值金额配置
export const getPrice = params => fetch('POST', '/Simulator/price', params)
// 支付
export const exchangePay = params => fetch('POST', '/coachPoints/pay', params)
// 是否使用盛付通支付
export const isShengPay = params =>fetch("POST", '/conf/getIsShengPay', params)



// WEBPACK FOOTER //
// ./src/http/api.js